import { Box } from "@mui/material";
import Flex from "../../../../../../components/Flex";
import { CHART_COLORS } from "../../../../../../components/app/provider/patient/chart";
import PatientClinicalRecords from "./patient-side-bar-components/PatientClinicalRecords";
import PatientInformationSection from "./patient-side-bar-components/PatientInformationSection";

const PatientInfoSection = ({ data }: { data: any }) => {
  return (
    <Flex
      flexDirection="column"
      height="100%"
      width="100%"
      bgcolor={CHART_COLORS.surfaceDefault}
    >
      <PatientInformationSection data={data} />
      <Box
        sx={{
          height: "1px",
          bgcolor: CHART_COLORS.border,
          flexShrink: 0,
        }}
      />
      <Flex sx={{ flex: 1, minHeight: 0 }}>
        <PatientClinicalRecords patientId={data?.uuid ?? ""} />
      </Flex>
    </Flex>
  );
};

export default PatientInfoSection;
